import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SystemAvatarIconComponent } from '@kuiper/icons';
import { AvatarComponent } from '../../../../ui-components/lib/avatar/avatar.component';
import { Creator } from '../../models/creator.model';
import { SYSTEM_AUTOTRIGGER_USER } from './system-autotrigger-user.constant';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-request-creator',
  imports: [AvatarComponent, SystemAvatarIconComponent, TranslocoPipe],
  templateUrl: './request-creator.component.html',
  styleUrl: './request-creator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestCreatorComponent {
  creator = input.required<Creator | null>();
  creatorData = computed(() => this.creator() ?? SYSTEM_AUTOTRIGGER_USER);
  size = input<size>('xs');
  sizeConfig = computed(() => this.sizeConfigMap.get(this.size()));
  isItemCenter = input<boolean>(true);

  private readonly sizeConfigMap = new Map<size, sizeConfig>([
    [
      'xs',
      {
        imgDimensions: { width: 0, height: 0 },
        size: 'list',
        textClasses: 'text-xs font-medium',
        systemAvatarSize: 'size-6',
      },
    ],
    [
      'sm',
      {
        imgDimensions: { width: 24, height: 24 },
        size: '',
        textClasses: 'text-sm',
        systemAvatarSize: 'size-7',
      },
    ],
  ]);
}

type size = 'xs' | 'sm';
type sizeConfig = {
  imgDimensions: { width: number; height: number };
  size: 'list' | '';
  textClasses: string;
  systemAvatarSize: 'size-6' | 'size-7';
};
